var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.label)+":")]),_vm._v(" \n  "),_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }